import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import isNumber from "lodash/isNumber";
import { Label } from "../../../../components/ui/label";
import { Switch } from "../../../../components/ui/switch";
import NumberInput from "../../../../components/shared/inputs/NumberInput";

interface SwitchNumberInputProps {
    label: string;
    unit: string;
    value?: number | null;
    onChange?: (value: number | null) => void;
}

function SwitchNumberInput({ label, unit, value, onChange }: SwitchNumberInputProps) {
    const { t } = useTranslation();
    const [enabled, setEnabled] = useState(isNumber(value));

    useEffect(() => {
        if (isNumber(value)) setEnabled(true);
    }, [value]);

    return (
        <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
            <div className="tw-flex tw-items-center tw-gap-2">
                <Switch
                    checked={enabled}
                    onCheckedChange={(checked: boolean) => {
                        setEnabled(checked);
                        onChange?.(checked ? 0 : null);
                    }}
                />
                <Label className="tw-m-0">{label}</Label>
            </div>

            {enabled && (
                <span className="tw-flex tw-gap-2 tw-items-center tw-w-28">
                    <NumberInput
                        className="tw-w-20"
                        decimalsLimit={0}
                        value={value}
                        onChange={(next) => onChange?.(next ?? null)}
                    />
                    <span className="tw-text-sm">{t(unit)}</span>
                </span>
            )}
        </div>
    );
}

export default SwitchNumberInput;
